import { FormContext, Typography } from '@s4l/ds'
import { useS4LContext } from '@s4l/react-context'
import React, { useContext } from 'react'

function FormErrorDisplay({ useCaseError }: { useCaseError: Error | undefined }) {
  const { i18n } = useS4LContext()
  const formContext = useContext(FormContext)

  const hasFormValidationErrors = !!formContext.errors.email
  const formWasSubmitted = formContext.formMetaData.submitted

  if (!useCaseError || hasFormValidationErrors || !formWasSubmitted) {
    return null
  }

  return (
    <Typography variant="caption" size="l" color="var(--color-error-500)">
      {i18n.formatMessage({ id: 'error.default' })}
    </Typography>
  )
}

FormErrorDisplay.displayName = 'FormErrorDisplay'
export default FormErrorDisplay
